import React from "react";
import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const RadioField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <RadioGroup value={input.value ?? ""} onChange={input.onChange}>
          <Stack direction={{ base: "column", md: "row" }}>
            {(field.options || []).map((option) => (
              <Radio key={option.value} value={String(option.value)} isDisabled={disabled || option.active === false}>
                {option.label}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      </FieldFrame>
    )}
  />
);

export default RadioField;
